import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {graphql} from 'react-apollo';

import Spinner from 'components/Spinner';

import {selectUserSelf, selectUserLoaded} from 'flows/session/selectors';

import {query} from 'flows/deal/allocate';
import Investor from './components/Investor';
import Save from './components/Save';

import './style.css';

export const AllocateInvestors = ({userLoaded, user, data: {loading, deal}}) => {
  if (loading || !userLoaded) {
    return (
      <div style={{textAlign: 'center'}}>
        <Spinner />
      </div>
    );
  }
  return (
    <div>
      <header styleName="header">
        <h2 styleName="h2">Investors</h2>
      </header>
      <section styleName="table">
        {
          deal.allocations &&
          deal.allocations.map(allocation =>
            <Investor allocation={allocation} key={allocation.id} user={user} />
          )
        }
        <Save deal={deal} />
      </section>
    </div>
  );
};


AllocateInvestors.propTypes = {
  deal: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  user: PropTypes.string,
  userLoaded: PropTypes.bool,
};

export const mapStore = store => ({
  user: selectUserSelf(store),
  userLoaded: selectUserLoaded(store),
});

const mapPropsToOptions = ({deal}) => ({variables: {dealId: deal.id}});

export default compose(
  graphql(query, {
    options: mapPropsToOptions,
  }),
  connect(mapStore),
)(AllocateInvestors);



// WEBPACK FOOTER //
// ./web/flows/deal/investors/allocate/index.js